import { SharedConstants } from '@shared/Constants';
import { TDBFieldMappingItem } from '@shared/interfaces/TDBFieldMappingItem';

export const REGION_BRICKS_MAPPINGS: Map<string, TDBFieldMappingItem> = new Map([
  [
    `id`,
    {
      columnWidth: SharedConstants.DEFAULT_COLUMN_WIDTH,
      fieldId: `id`,
      name: `brick Id`,
      isSortable: false,
      visibleInSummary: false,
      visibleInShortSummary: false,
      systemProp: false,
      isEditable: false,
      export: true
    }
  ],
  [
    `name`,
    {
      columnWidth: SharedConstants.DEFAULT_COLUMN_WIDTH,
      fieldId: `name`,
      name: `brick name`,
      isSortable: false,
      visibleInSummary: false,
      visibleInShortSummary: true,
      systemProp: false,
      isEditable: false,
      export: true
    }
  ],
  [
    `year`,
    {
      columnWidth: SharedConstants.DEFAULT_COLUMN_WIDTH,
      fieldId: `year`,
      name: `Year`,
      isSortable: false,
      visibleInSummary: false,
      visibleInShortSummary: true,
      systemProp: false,
      isEditable: false,
      export: true
    }
  ],
  [
    `month`,
    {
      columnWidth: SharedConstants.DEFAULT_COLUMN_WIDTH,
      fieldId: `month`,
      name: `month`,
      isSortable: false,
      visibleInSummary: false,
      visibleInShortSummary: true,
      systemProp: false,
      isEditable: false,
      export: true
    }
  ],
  [
    `salesInEuro`,
    {
      columnWidth: SharedConstants.DEFAULT_COLUMN_WIDTH,
      fieldId: `salesInEuro`,
      name: `sales in €`,
      isSortable: false,
      visibleInSummary: false,
      visibleInShortSummary: true,
      systemProp: false,
      isEditable: false,
      export: true
    }
  ],
  [
    `patients`,
    {
      columnWidth: SharedConstants.DEFAULT_COLUMN_WIDTH,
      fieldId: `patients`,
      name: `patients`,
      isSortable: false,
      visibleInSummary: false,
      visibleInShortSummary: true,
      systemProp: false,
      isEditable: false,
      export: true
    }
  ]
]);
